import {useFetchData} from 'hooks/api/useFetchData'
import {EmploymentType} from 'types/api/employmentTypes/employmentType'

export const useFetchEmploymentTypes = () => {
  const path = '/api/employment_types'
  return useFetchData<EmploymentType[]>(path, [], {})
}
